import React from 'react';
import PropTypes from 'prop-types';
import AutocompleteSelect from 'chameleon/ui-stack/ui/forms/autocomplete-select';
import cn from 'classnames';

import './DropdownFilter.scss';

const NOTHING_SELECTED_VALUE = 'all-value';

const DropdownFilter = (props) => {
  const {
    keyValue: { label, value },
    includeAll,
    allLabel,
    activeItem,
    setActiveItem,
    items,
    placeholder,
    className,
    listClassName,
  } = props;

  const onChange = (item) => {
    setActiveItem(item);
  };

  let options = items;
  let allValuesOption = null;
  let selectedValue = activeItem
    ? {
        label: activeItem[label],
        value: activeItem[value],
      }
    : null;

  if (includeAll) {
    allValuesOption = {
      label: allLabel,
      value: NOTHING_SELECTED_VALUE,
    };

    options = [allValuesOption, ...options];

    if (!selectedValue) {
      selectedValue = allValuesOption;
    }
  }

  return (
    <AutocompleteSelect
      className={cn(className, 'DropdownFilter-root')}
      options={options}
      value={selectedValue || {}}
      onChange={onChange}
      disableDropdown={options.length <= 1}
      placeholder={{
        label: placeholder,
      }}
      listClassName={listClassName}
    />
  );
};

DropdownFilter.displayName = 'DropdownFilter';

DropdownFilter.propTypes = {
  /**
   * Bool for using the All option
   * */
  includeAll: PropTypes.bool,
  /**
   * All label for first option
   * */
  allLabel: PropTypes.string,
  /**
   * Active item used for finding the item to auto-select
   * */
  activeItem: PropTypes.object,
  /**
   * Call back function for setting active item
   * */
  setActiveItem: PropTypes.func.isRequired,
  /**
   * List of options that select is displaying
   * */
  items: PropTypes.array.isRequired,
  /**
   * Key, value string props needed for identifying the values in items
   * */
  keyValue: PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
  }).isRequired,
  /**
   * String for defining a label on a autocomplete select box.
   * */
  placeholder: PropTypes.string,
  /**
   * Optional class name to add to the dropdown
   * */
  className: PropTypes.string,
  /**
   * Optional, classname to add to the list items
   */
  listClassName: PropTypes.string,
};

DropdownFilter.defaultProps = {
  includeAll: true,
  allLabel: 'All',
  activeItem: null,
  placeholder: 'Select a Value',
  listClassName: '',
};

export default DropdownFilter;
